import { apiRequest } from "./client";

export interface NotificationOut {
  id: number;
  type: string;
  title: string;
  body: string | null;
  link_url: string | null;
  payload: Record<string, unknown>;
  read_at: string | null;
  created_at: string;
}

export interface NotificationsOut {
  items: NotificationOut[];
  unread_count: number;
}

export interface UnreadCountOut {
  unread_count: number;
}

export function listNotifications(opts: { unread_only?: boolean; limit?: number } = {}): Promise<NotificationsOut> {
  const u = new URLSearchParams();
  if (opts.unread_only) u.set("unread_only", "true");
  if (opts.limit) u.set("limit", String(opts.limit));
  const s = u.toString();
  return apiRequest<NotificationsOut>(`/me/notifications${s ? `?${s}` : ""}`);
}

export function unreadCount(): Promise<UnreadCountOut> {
  return apiRequest<UnreadCountOut>("/me/notifications/unread-count");
}

export function markRead(id: number): Promise<void> {
  return apiRequest<void>(`/me/notifications/${id}/read`, { method: "POST" });
}

export function markAllRead(): Promise<UnreadCountOut> {
  return apiRequest<UnreadCountOut>("/me/notifications/read-all", { method: "POST" });
}
